import React from 'react'
import * as Icons from '../../assets/svg/icons'
import { sanitizeHtml } from '../../utils/helper/security';
import { normalizeBackendAssetUrl } from '../../utils/helper/url';

export const PickedUpSuccessfully = ({ setShowToast }) => {
	return (
		<React.Fragment>
			<div className="bg-gray-900 fixed  bottom-0 z-50 w-full text-sm text-white  shadow-lg ">
				<div className="flex items-center gap-2 p-4">
					<Icons.ToastMessageIcon />
					Picked Up Successfully
					<div className="ml-auto">
						<button type="button" onClick={() => setShowToast(false)}
							className="inline-flex justify-center items-center w-8 h-8  text-white hover:text-white 
												opacity-50 hover:opacity-100 
												focus:outline-none focus:opacity-100">
							<span className="sr-only">Close</span>
							<Icons.ToastMessageIcon2 />
						</button>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}


export const DeliveryErrorMessages = ({ setShowErrorToast, message, onDismiss }) => {
	const defaultText = 'Oops! Got an issue while processing delivery.Please try again.';
	const displayText = (typeof message === 'string' && message.trim()) ? message.trim() : defaultText;
	const dismiss = () => {
		if (typeof onDismiss === 'function') {
			onDismiss();
		}
		setShowErrorToast(false);
	};
	return (
		<div
			className="bg-red-800 fixed  bottom-0 w-full  z-50 text-sm text-white shadow-lg "
			role="alert">
			<div className="flex gap-2 p-4">
				{displayText}
				<div className="ml-auto">
					<button type="button" onClick={dismiss}
						className="inline-flex flex-shrink-0 justify-center items-center size-5  text-white hover:text-white opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100">
						<span className="sr-only">Close</span>
						<Icons.ToastMessageIcon2 />
					</button>
				</div>
			</div>
		</div>
	)
}

export const DeliverSuccessfull = ({ setShowSuccessToast }) => {
	return (
		<React.Fragment>
			<div className="bg-[#10b981] fixed  bottom-0 z-50 w-full text-sm text-white  shadow-lg ">
				<div className="flex items-center gap-2 p-4">
					<Icons.ToastMessageIcon />
                        Prescription Delivered.
					<div className="ml-auto">
						<button type="button" onClick={() => setShowSuccessToast(false)} className="inline-flex justify-center items-center w-8 h-8  text-white hover:text-white opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100">
							<span className="sr-only">Close</span>
							<Icons.ToastMessageIcon2 />
						</button>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}


export const MissedDeliveryErrorMessages = ({ setMissedDeliveryErrorToast, message, onDismiss }) => {
	const defaultText = 'Oops! Got an issue while Missing Delivery.';
	const displayText = (typeof message === 'string' && message.trim()) ? message.trim() : defaultText;
	const dismiss = () => {
		if (typeof onDismiss === 'function') {
			onDismiss();
		}
		setMissedDeliveryErrorToast(false);
	};
	return (
		<div
			className="bg-red-800 w-full fixed  bottom-0 z-50  text-sm text-white  shadow-lg "
			role="alert">
			<div className="flex gap-2 p-4">
				{displayText}
				<div className="ml-auto">
					<button type="button" onClick={dismiss}
						className="inline-flex flex-shrink-0 justify-center items-center size-5 rounded-lg text-white hover:text-white opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100">
						<span className="sr-only">Close</span>
						<Icons.ToastMessageIcon2 />
					</button>
				</div>
			</div>
		</div>
	)
}

export const DeliveryDoneByAnotherDriver = ({ setMissedDeliveryErrorToast, message }) => {
	return (
		<div
			className="bg-red-800 w-full fixed  bottom-0 z-50  text-sm text-white  shadow-lg "
			role="alert">
			<div className="flex gap-2 p-4">
				{message || 'Delivery done by another Driver.'}
				<div className="ml-auto">
					<button type="button" onClick={() => setMissedDeliveryErrorToast(false)}
						className="inline-flex flex-shrink-0 justify-center items-center size-5 rounded-lg text-white hover:text-white opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100">
						<span className="sr-only">Close</span>
						<Icons.ToastMessageIcon2 />
					</button>
				</div>
			</div>
		</div>
	)
}

export const PatientConsentErrorMessage = ({ setShowErrorToast }) => {
	return (
		<div
			className="bg-red-800 fixed  bottom-0 z-50 text-sm text-white shadow-lg "
			role="alert">
			<div className="flex gap-2 p-4">
				Oops! Got an issue while adding Details Please try to add again.
				<div className="ml-auto">
					<button type="button" onClick={() => setShowErrorToast(false)}
						className="inline-flex flex-shrink-0 justify-center items-center size-5  text-white hover:text-white opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100">
						<span className="sr-only">Close</span>
						<Icons.ToastMessageIcon2 />
					</button>
				</div>
			</div>
		</div>
	)
}

export const SignatureErrorMessage = ({ setShowErrorToast, message }) => {
	return (
		<div
			className="bg-red-800 w-full fixed  bottom-0  z-50 text-sm text-white shadow-lg "
			role="alert">
			<div className="flex gap-2 p-4">
				{message}
				<div className="ml-auto">
					<button type="button" onClick={() => setShowErrorToast(false)}
						className="inline-flex flex-shrink-0 justify-center items-center size-5  text-white hover:text-white opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100">
						<span className="sr-only">Close</span>
						<Icons.ToastMessageIcon2 />
					</button>
				</div>
			</div>
		</div>
	)
}

export const ErrorMessage = ({ setShowToast, message }) => {

	return (
		<div
			className="bg-red-800 fixed bottom-0 left-0 right-0 z-50 text-sm text-white shadow-lg"
			role="alert">
			<div className="flex gap-2 p-4">
				{message}
				<div className="ml-auto">
					<button type="button" onClick={setShowToast}
						className="inline-flex flex-shrink-0 justify-center items-center size-5  text-white hover:text-white opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100">
						<span className="sr-only">Close</span>
						<Icons.ToastMessageIcon2 />
					</button>
				</div>
			</div>
		</div>
	)
}

export const SOS_EmergencyEnabledMessage = ({ setShowToast, message }) => {
	const safeMessage = sanitizeHtml(message);

	return (
		<div
			className="bg-red-800 w-full fixed  bottom-0  z-50 text-sm text-white shadow-lg "
			role="alert">
			<div className="flex gap-2 p-4">
				<div dangerouslySetInnerHTML={{ __html: safeMessage }} className='gap-4' style={{ display: 'flex', marginRight: '10px' }} />
				<div className="ml-auto">
					<button type="button" onClick={setShowToast}
						className="inline-flex flex-shrink-0 justify-center items-center size-5  text-white hover:text-white opacity-50 hover:opacity-100 
						focus:outline-none focus:opacity-100">
						<span className="sr-only">Close</span>
						<Icons.ToastMessageIcon2 />
					</button>
				</div>
			</div>
		</div>
	)
}

export const SuccessMessage = ({ message, setShowToast }) => {
	return (
		<React.Fragment>
			<div className="bg-[#10b981] fixed bottom-0 left-0 right-0 z-50 text-sm text-white shadow-lg">
				<div className="flex items-center gap-2 p-4">
					<Icons.ToastMessageIcon />
					{message}
					<div className="ml-auto">
						<button type="button" onClick={setShowToast} className="inline-flex justify-center items-center w-8 h-8  text-white hover:text-white 
								opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100">
							<span className="sr-only">Close</span>
							<Icons.ToastMessageIcon2 />
						</button>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

export const NewMessageNotification = ({ data }) => {

	return (
		<React.Fragment>
			<div className='bg-black m-2 text-sm text-white z-50 rounded-full z-50 shadow-lg ' style={{ backgroundColor: '#1A1C24' }}>
				<div className="flex items-center gap-2 p-4 text-white" >
					<img src={normalizeBackendAssetUrl(data?.thumbnail)} alt="profile" className='w-12 h-12 rounded-full shadow-lg border border-1 border-white' />
					<div>
						<p className='font-bold'>{data?.title}</p>
						<p className='text-sm'>{data?.body}</p>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}
